/**
 * Authorisation service implementation
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 28/02/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      28/02/2025    Akhil Soman       Creating new File
 */

import axios from "axios";
import Constant from "../global/Constant.ts";

class AuthService {
  signup(url: string, data: any) {
    return axios.post(Constant.VBaseUrl + url, data);
  }
}

const authService = new AuthService();
export default authService;
